// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1M44X","fileBtn":"File_fileBtn__2r4BG","closeBtn":"File_closeBtn__tHk0v","fileSelected":"File_fileSelected__13Ofd","disabled":"File_disabled__dPDi9"};